import Axios from "axios";
import {
  SET_INCOME_STATEMENT_REPORT,
  UNSET_INCOME_STATEMENT_REPORT,
} from "@/store/mutation-types";
import {
  getIncomeStatementReport,
} from "@/store/api";

const state = {
  incomeStatementReport: [],
};

const getters = {
  getIncomeStatementReport(state) {
    return state.incomeStatementReport;
  },
};

const mutations = {
  [SET_INCOME_STATEMENT_REPORT](state, data) {
    state.incomeStatementReport = data;
  },
  [UNSET_INCOME_STATEMENT_REPORT](state) {
    state.incomeStatementReport = [];
  },
};

const actions = {
  getIncomeStatement({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getIncomeStatementReport}`, { params: data })
        .then((response) => {
          commit(SET_INCOME_STATEMENT_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_INCOME_STATEMENT_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

